import React from 'react';
import { useHistory } from 'react-router-dom';
import BreadCrumbs from '../../Common/BreadCrumbs';
import { PrimaryButton } from '../../Common';

const DeletedRecord = ({
    recordType = 'Record',
    recordId,
    backUrl,
    backLabel,
}) => {
    const history = useHistory();

    const headingLabel = recordId
        ? `${recordType} #${recordId} has been deleted`
        : `${recordType} has been deleted`;

    const onBack = () => {
        if (backUrl) {
            history.push(backUrl);
        } else {
            history.goBack();
        }
    };

    return (
        <>
            <BreadCrumbs
                path={[
                    { text: headingLabel, onClick: null }
                ]}
            />

            <div className="flex f-col f-center">

                <img src="/images/Error404.svg" />

                <br />

                <p className="error404-text">{headingLabel}.</p>

                <br />

                <p className="error404-text-small">
                    This record is no longer available. Use the button below to return.
                </p>

                <br />

                <PrimaryButton
                    buttonText={backLabel || 'Go Back'}
                    onClick={onBack}
                />
            </div>
        </>
    );
};

export default DeletedRecord;
